module.exports = __webpack_public_path__ + "img/injective-6.72a65d55.webp";